//React
import React from "react";

//UI
import { Select } from "../../Common/Input/index";

//processing
const moment = require("moment-timezone");

const timeZones = moment.tz.names();

const timezonOptions = timeZones.map((zone) => {
  return {
    value: zone,
    label: zone,
  };
});

const TimeZoneSelect = (props) => {
  const { onChange, value } = props;

  return (
    <Select
      value={value}
      onChange={onChange}
      showSearch
      options={timezonOptions}
      placeholder="Time Zone"
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default TimeZoneSelect;
